export const canRevealRuntimeKnockoutTeams = (
   structure: any,
   runtime: any
) => {
   // Multi-stage runtime resolves each group-fed slot only after its source
   // group is confirmed; later groups must not hide an earlier confirmed wave.
   if (structure?.qualifierGroups?.length) return true;
   const dependsOnGroupPositions = (structure?.matches || []).some(
      (match: any) =>
         [match.homeSource, match.awaySource].some(
            source => source?.sourceType === 'GROUP_POSITION'
         )
   );

   return !dependsOnGroupPositions || runtime?.groupReview?.status === 'CONFIRMED';
};
